import { tns } from 'tiny-slider/src/tiny-slider'

// Cases
export function courseSlider (el) {
	const element = document.querySelector(el)
	// don't start function if the element is not on the page
	if (!element) return
	const slider = tns({
		container: el,
		items: 3,
		nav: false,
		gutter: 50,
		//controlsContainer: element.nextElementSibling,
		autoplay: false,
		mouseDrag: true,
		autoHeight: true
	})
}

// Teamslider
export function reviewSlider (el) {
	const element = document.querySelector(el)
	// don't start function if the element is not on the page
	if (!element) return
	const slider = tns({
		mode: 'gallery',
		container: el,
		items: 1,
		mouseDrag: true,
		autoplay: false,
		autoplayButtonOutput: false,
		loop: true,
		autoHeight: true,
		controlsContainer: element.nextElementSibling,
		nav: false,
  		animateDelay: 300

	})
	//document.querySelector('.reviews .next').addEventListener('click', () => slider.goTo('next'))
	//document.querySelector('.reviews .prev').addEventListener('click', () => slider.goTo('prev'))
}

// Teamslider
export function clientSlider (el) {
	const element = document.querySelector(el)
	// don't start function if the element is not on the page
	if (!element) return
	const slider = tns({
		container: el,
		items: 1,
		responsive: {
	      640: {
	        edgePadding: 20,
	        gutter: 20,
	        items: 2
	      },
	      700: {
	        gutter: 30
	      },
	      900: {
	        items: 3
	      },
	      1200: {
	        items: 5
	      }
	    },
		mouseDrag: true,
		autoplay: true,
		autoplayButtonOutput: false,
		loop: true,
		autoHeight: true,
		//fixedWidth: 170,
		//fixedHeight: 170,
		// autoplayTimeout: 7500,
		//controlsContainer: document.getElementById('#reviewsnav'),
		controls: false,
		nav: false,
		//animateIn: 'fadeInUp',
		//animateOut: 'fadeOutUp'
		//animateIn: 'fadeIn',
  		//animateOut: 'fadeOut',
  		// animateNormal: 'tns-normal',
  		animateDelay: 300
	})
	//document.querySelector('.reviews .next').addEventListener('click', () => slider.goTo('next'))
	//document.querySelector('.reviews .prev').addEventListener('click', () => slider.goTo('prev'))
}

// blog slider
export function blogSlider (el) {
	const element = document.querySelector(el)
	// don't start function if the element is not on the page
	if (!element) return
	const slider = tns({
		container: el,
		responsive: {
			0: {
				items: 1,
				gutter: 20,
				edgePadding: 48
			},
			768: {
				fixedWidth: 300,
				gutter: 24,
				edgePadding: 48
			},
			960: {
				fixedWidth: 300,
				gutter: 48,
				edgePadding: 48
			}
		},
		//startindex: 1,
		gutter: 48,
		autoplay: false,
		loop: false,
		autoplayHoverPause: true,
		mouseDrag: true,
		controlsContainer: '.blogs__nav',
		autoHeight: false,
		speed: 500,
		nav: false,
		autoplayButtonOutput: false
	})

	slider.events.on('indexChanged', () => {
		const info = slider.getInfo()
		const prev = info.slideItems[info.indexCached]
		prev.classList.add('away')
		setTimeout(() => prev.classList.remove('away'), 1500)
	})
}